import { Component } from '@angular/core';


@Component({
    selector: 'app-testimonials',
    imports: [],
    templateUrl: './testimonials.component.html'
})
export class TestimonialsComponent {
  testimonials = [
    {
      quote: "Notre outil a réduit le temps d’analyse des contrats de 80%. C'est un changement radical pour notre équipe juridique.",
      name: "Claire Dubois",
      title: "Directrice Juridique, Innovatech",
      avatar: "https://i.pravatar.cc/100?u=a042581f4e29026704d"
    },
    {
      quote: "La capacité à extraire les points clés et les risques en quelques secondes nous permet de prendre des décisions plus rapides et mieux informées.",
      name: "Marc Antoine",
      title: "CEO, Solutions B2B",
      avatar: "https://i.pravatar.cc/100?u=a042581f4e29026705d"
    },
    {
      quote: "Indispensable pour notre due diligence. Nous analysons des dizaines de rapports financiers par semaine sans effort.",
      name: "Sophie Laurent",
      title: "Analyste Financier, Capital Invest",
      avatar: "https://i.pravatar.cc/100?u=a042581f4e29026706d"
    }
  ];

  // trackBy pour optimiser le rendu DOM
  trackTestimonial(index: number, testimonial: any): string {
    return testimonial.name; // clé unique
  }
}
